"use client"

import { CreateChampignonForm } from "./components/create-champignon-form";
import { EditChampignonForm } from "./components/edit-champignon-form";

interface ChampignonsFormProps {
  id?: string;
  champignonsId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function ChampignonsForm({ id, champignonsId, onCancel, onSuccess }: ChampignonsFormProps) {
  // Check if we're in edit mode by looking for either id or champignonsId
  const isEditing = !!id || !!champignonsId;

  if (isEditing) {
    return (
      <EditChampignonForm
        id={id || champignonsId?.toString() || ""}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <CreateChampignonForm
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
}
